const NO_IMAGE = 'https://opensooqui2.os-cdn.com/noImage/no-image-{lang}.png';
const NO_IMAGE_SHOBIDAK= 'https://opensooqui-new.s3.amazonaws.com/api/v/icons/misc/shobiddak_{lang}.png';
const DEFAULT_AVATAR = 'https://opensooqui-new.s3.amazonaws.com/api/v/icons/misc/profile_avatar.png';
export {NO_IMAGE,DEFAULT_AVATAR,NO_IMAGE_SHOBIDAK}